import { Icon } from "@/shared/components";
import { cn } from "@/shared/utils";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import * as React from "react";

function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
    return (
        <CheckboxPrimitive.Root
            data-slot="checkbox"
            className={cn(
                "peer border-input-default dark:bg-input/30 data-[state=checked]:bg-success-default data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-success-default focus-visible:outline-focus aria-invalid:outline-error disabled:bg-alpha-default data-[state=checked]:disabled:bg-alpha-default flex size-4 shrink-0 items-center justify-center rounded-[4px] border shadow-xs transition-shadow outline-none hover:cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-solid disabled:cursor-not-allowed disabled:border-transparent aria-invalid:border-transparent aria-invalid:outline-2 data-[state=checked]:border-transparent",
                className
            )}
            {...props}
        >
            <CheckboxPrimitive.Indicator data-slot="checkbox-indicator" className="flex items-center justify-center transition-none">
                <Icon name="check" size="xs" className="text-content-default-inverse" strokeWidth="thick" />
            </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
    );
}

export { Checkbox };
